import React from "react";
import { useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import {
  CASUAL_INTERVIEW_URL,
  NEW_GRAD_ENGINEER_URL,
  NEW_GRAD_SALES_URL
} from "../config/careerLinks";
import "./CasualCTA.css";

const isNewGraduateLanding = (pathname = "") =>
  String(pathname).split("?")[0].replace(/\/$/, "") === "/newgraduate";

const CasualCTA = () => {
  const { pathname } = useLocation();
  const showNewGradEntry = isNewGraduateLanding(pathname);

  return (
    <section className="casual-cta-section">
      <div className="casual-cta-container">
        <div className="casual-cta-header">
          <p className="casual-cta-label">CASUAL TALK</p>
          <h2 className="casual-cta-title">カジュアル面談はこちら</h2>
          <p className="casual-cta-lead">
            採用面談にハードルを感じている方は、まずはカジュアル面談へ！
            <br />
            会社についての疑問／質問やあなたの今や未来について、ざっくばらんにお話ししましょう。
          </p>
        </div>
        <div className="casual-cta-actions">
          <a
            href={CASUAL_INTERVIEW_URL}
            target="_blank"
            rel="noreferrer noopener"
            className="casual-cta-btn casual-cta-btn-primary"
          >
            <span className="casual-cta-btn-text">カジュアル面談を申し込む</span>
            <ArrowRight className="casual-cta-btn-arrow" size={20} strokeWidth={2.5} />
          </a>
          <a
            href="https://line.me/R/ti/p/@308bzbxk"
            className="casual-cta-btn casual-cta-btn-line"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="casual-cta-btn-text">公式LINEからカジュアル面談へ</span>
            <ArrowRight className="casual-cta-btn-arrow" size={20} strokeWidth={2.5} />
          </a>
        </div>

        {showNewGradEntry && (
          <div className="casual-cta-entry">
            <p className="casual-cta-entry-label">2028年卒エントリー</p>
            <div className="casual-cta-entry-actions">
              <a
                href={NEW_GRAD_ENGINEER_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="casual-cta-btn casual-cta-btn-entry-outline"
              >
                <span className="casual-cta-btn-text">
                  <span className="casual-cta-btn-kicker">［新卒2028］</span>
                  <span className="casual-cta-btn-role">エンジニア</span>
                </span>
                <ArrowRight className="casual-cta-btn-arrow" size={20} strokeWidth={2.5} />
              </a>
              <a
                href={NEW_GRAD_SALES_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="casual-cta-btn casual-cta-btn-entry-outline"
              >
                <span className="casual-cta-btn-text">
                  <span className="casual-cta-btn-kicker">［新卒2028］</span>
                  <span className="casual-cta-btn-role">営業職</span>
                </span>
                <ArrowRight className="casual-cta-btn-arrow" size={20} strokeWidth={2.5} />
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CasualCTA;
